import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Thresholds } from '@core/models/threshold.model';
import { environment } from '@env/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ThresholdService {
  private http = inject(HttpClient);

  private baseUrl: string = environment.apiUrl + '/threshold';

  public getThresholds(): Observable<Thresholds> {
    return this.http.get<Thresholds>(this.baseUrl);
  }

  public getThresholdsAttributeList(): Observable<Thresholds> {
    return this.http.get<Thresholds>(this.baseUrl + '/attribute-list');
  }

  public upsertThresholds(thresholds: Thresholds): Observable<Thresholds> {
    return this.http.post<Thresholds>(this.baseUrl, thresholds);
  }
}
